import { Component, DestroyRef, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IonContent, IonProgressBar, IonSpinner } from '@ionic/angular/standalone';

@Component({
	selector: 'app-checking-payment-modal',
	template: `
		<ion-content class="ion-padding">
			<div class="checking-payment-content">
				<ion-spinner name="circular"></ion-spinner>
				<h2>{{ 'payment.checking.title' | translate }}</h2>
				<p>{{ 'payment.checking.message' | translate }}</p>

				<div class="progress-container">
					<ion-progress-bar [value]="progress"></ion-progress-bar>
				</div>
			</div>
		</ion-content>
	`,
	styles: [
		`
			.checking-payment-content {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				text-align: center;
				min-height: 200px;
				padding: 20px;
			}

			ion-spinner {
				width: 48px;
				height: 48px;
				margin-bottom: 20px;
			}

			h2 {
				margin: 0 0 8px;
				font-size: 20px;
				font-weight: 500;
			}

			p {
				margin: 0 0 20px;
				color: var(--ion-color-medium);
			}

			.progress-container {
				width: 100%;
				max-width: 300px;
				margin-top: 16px;
			}
		`,
	],
})
export class CheckingPaymentModalComponent implements OnInit {
	progress = 0;

	constructor(
		private modalCtrl: ModalController,
		private translate: TranslateService,
		private destroyRef: DestroyRef
	) {}

	static async show(modalCtrl: ModalController): Promise<HTMLIonModalElement> {
		const modal = await modalCtrl.create({
			component: CheckingPaymentModalComponent,
			cssClass: 'checking-payment-modal',
			backdropDismiss: false,
			keyboardClose: false,
		});

		await modal.present();
		return modal;
	}

	ngOnInit() {
		// Update progress bar every 150ms for smooth animation
		const interval = 150;
		const duration = 15000; // 15 seconds
		const steps = duration / interval;

		const subscription = timer(0, interval)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(step => {
				this.progress = Math.min(step / steps, 1);

				if (this.progress >= 1) {
					subscription.unsubscribe();
					this.modalCtrl.dismiss();
				}
			});
	}
}
